import React, { useEffect, useState } from 'react';
import './style.scss';

interface Props {
  email: string;
  expiresAt: number;
}

const ImitationBanner = ({ email, expiresAt }: Props) => {
  const [remainingSeconds, setRemainingSeconds] = useState(() =>
    Math.max(expiresAt - Math.floor(Date.now() / 1000), 0)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);
      const remaining = Math.max(expiresAt - now, 0);
      setRemainingSeconds(remaining);
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  if (remainingSeconds <= 0) return null;

  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;

  return (
    <div className="imitation-banner">
      You are currently logged in as: <strong>{email}</strong>, this session will expire in:
      <strong className="time-box">
        {minutes}:{seconds.toString().padStart(2, '0')} minute{minutes !== 1 ? 's' : ''}
      </strong>
    </div>
  );
};

export default ImitationBanner;
